module.exports = __webpack_public_path__ + "img/amex.8331b695.png";